import { createBrowserRouter } from "react-router-dom";
import Main from "Layouts/Main";
import AuthLayout from "Layouts/AuthLayout"; // Layout WITHOUT Navbar/Footer
import LocationLayout from "Layouts/LocationLayout";
import Location from "Pages/Location/Location";
import AdminRoute from "Components/Admin/AdminRoute";
import AdminDashboard from "Pages/Admin/AdminDashboard";
import TournamentFormPage from "Pages/Admin/TournamentFormPage";
import TournamentProgressPage from "Pages/Tournament/TournamentProgressPage";
import Home from "Pages/Home/Home/Home";
import Error from "Pages/Shared/Error/Error";
import Login from "Pages/Auth/Login";
import Signup from "Pages/Auth/Signup";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    errorElement: <Error />,
    children: [{ path: "/", element: <Home /> }],
  },
  {
    path: "/",
    element: <AuthLayout />, // Layout without Navbar/Footer
    children: [
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <Signup /> },
    ],
  },
  {
    path: "/",
    element: <LocationLayout />,
    children: [
      { path: "/locations/:locationId", element: <Location /> },
      {
        path: "/locations/tournaments/new/:locationId",
        element: <TournamentFormPage />,
      },
      {
        path: "/locations/tournaments/edit/:tournamentId",
        element: <TournamentFormPage />,
      },
      {
        path: "/locations/tournaments/:tournamentId/progress",
        element: <TournamentProgressPage />,
      },
    ],
  },
  {
    path: "/admin",
    element: <AdminRoute />, // Protect admin pages
    children: [
      { path: "/admin/dashboard", element: <AdminDashboard /> },
    ],
  },
]);

export default router;


